import { Component, EventEmitter, Output } from '@angular/core';
import { Configurator } from '@obo-main/components/chatBot/DTO/Conversation';
import { ChatService } from '@obo-main/components/chatBot/services/chat.service';
import { ExampleQuestionComponent } from '@obo-main/components/chatBot/components/example-questions/example-question/example-question.component';
import { NgForOf } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-example-questions',
    standalone: true,
    imports: [ExampleQuestionComponent, NgForOf],
    templateUrl: './example-questions.component.html',
    styleUrl: './example-questions.component.scss'
})
export class ExampleQuestionsComponent {
    @Output()
    public exampleQuestionClicked = new EventEmitter<string>();

    constructor(private chatService: ChatService, private translateService: TranslateService) {}

    public getExampleQuestions(): string[] {
        const configurator: Configurator = this.chatService.configurator;
        switch (configurator) {
            case 'underfloor':
                return [
                    this.translateService.instant('CHATBOT_EXAMPLE_QUESTION_UNDERFLOOR_1'),
                    this.translateService.instant('CHATBOT_EXAMPLE_QUESTION_UNDERFLOOR_2'),
                    this.translateService.instant('CHATBOT_EXAMPLE_QUESTION_UNDERFLOOR_3'),
                    this.translateService.instant('CHATBOT_EXAMPLE_QUESTION_UNDERFLOOR_4')
                ];
            default:
                return [];
        }
    }

    protected onExampleQuestionClicked(question: string): void {
        this.exampleQuestionClicked.emit(question);
    }
}
